import { useState, useCallback } from 'react';
import { m207Api } from '../../../services/m207Api';

export function useM207Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const res = await m207Api.list(1, 10000);
    const ids = (res.data || []).map(r => r.fm210_01).filter(Boolean);
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
